module.exports = __webpack_public_path__ + "static/Artboard-1-86dd006e226be46fe16c48495a146975.png";